export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_1.4d6948f6.mp3";